module.exports = __webpack_public_path__ + "img/KG-Coordinator.7d644bb0.png";